/** @flow */
import React, { type ElementProps } from "react";
import classNames from "classnames";
import { Tooltip as BsTooltip } from "reactstrap";
import "./tooltip.style.scss";

type TooltipProps = {
  ...ElementProps<typeof BsTooltip>,
  children: React$Node,
};

const Tooltip = (props: TooltipProps) => (
  <BsTooltip className={classNames("extended-tooltip", props.className)} {...props}>
    {props.children}
  </BsTooltip>
);

export default Tooltip;
